exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-57b57063] .el-input-number--small{width:440px!important}[data-v-57b57063] .el-input.is-disabled .el-input__inner{color:#000}", ""]);

// exports
